import { render, staticRenderFns } from "./SimpleMessagesShow.vue?vue&type=template&id=248d4137&scoped=true&"
import script from "./SimpleMessagesShow.vue?vue&type=script&lang=js&"
export * from "./SimpleMessagesShow.vue?vue&type=script&lang=js&"
import style0 from "./SimpleMessagesShow.vue?vue&type=style&index=0&id=248d4137&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248d4137",
  null
  
)

export default component.exports